class DeferredMedia extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.button = this.querySelector('[data-deferred-media-button]');
    this.button?.addEventListener('click', this.load, { signal: this.controller.signal });
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.pause();
  }

  load = () => {
    if (this.hasAttribute('loaded')) {
      this.play();
      return;
    }
    const template = this.querySelector('template');
    if (!(template instanceof HTMLTemplateElement)) return;

    this.replaceChildren(template.content.cloneNode(true));
    this.setAttribute('loaded', '');
    const media = this.querySelector('video, iframe, model-viewer');
    if (media instanceof HTMLVideoElement) media.play().catch(() => {});
    if (media?.matches('model-viewer')) {
      const setupModelViewer = () => {
        if (!window.Shopify?.ModelViewerUI) return;
        this.modelViewerUI = new window.Shopify.ModelViewerUI(media);
        this.modelViewerUI.play?.();
      };
      if (window.Shopify?.ModelViewerUI) setupModelViewer();
      else window.Shopify?.loadFeatures?.([{ name: 'model-viewer-ui', version: '1.0', onLoad: setupModelViewer }]);
    }
    if (media instanceof HTMLElement) media.focus?.({ preventScroll: true });
  };

  play() {
    const video = this.querySelector('video');
    if (video instanceof HTMLVideoElement) video.play().catch(() => {});
    this.modelViewerUI?.play?.();
  }

  pause() {
    const video = this.querySelector('video');
    if (video instanceof HTMLVideoElement) video.pause();
    const iframe = this.querySelector('iframe');
    iframe?.contentWindow?.postMessage(
      iframe.dataset.videoType === 'youtube'
        ? '{"event":"command","func":"pauseVideo","args":""}'
        : '{"method":"pause"}',
      '*'
    );
    this.modelViewerUI?.pause?.();
  }
}

function setupShopifyXR(errors) {
  if (errors) return;
  if (!window.ShopifyXR) {
    document.addEventListener('shopify_xr_initialized', () => setupShopifyXR(), { once: true });
    return;
  }
  for (const modelJSON of document.querySelectorAll('[id^="ProductModelJSON-"]')) {
    window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent || '[]'));
    modelJSON.remove();
  }
  window.ShopifyXR.setupXRElements();
}

function loadShopifyXR() {
  if (!document.querySelector('[id^="ProductModelJSON-"]')) return;
  if (!document.getElementById('ModelViewerStyle')) {
    const stylesheet = document.createElement('link');
    stylesheet.id = 'ModelViewerStyle';
    stylesheet.rel = 'stylesheet';
    stylesheet.href = 'https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css';
    document.head.append(stylesheet);
  }
  window.Shopify?.loadFeatures?.([{ name: 'shopify-xr', version: '1.0', onLoad: setupShopifyXR }]);
}

window.BabySupriseProductModel = { load: loadShopifyXR };
loadShopifyXR();

if (!customElements.get('deferred-media')) customElements.define('deferred-media', DeferredMedia);
